import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { login, logout } from '../store/authSlice';
import { clearSession, saveToken } from '../utils/authUtils';
import { Container, TextField, Button, Box, Typography, Alert } from '@mui/material';
import api from '../utils/axiosConfig';



const Login = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {

            const body = { username, password };
            // For login, we don't want to send the auth token since we don't have one yet
            const response = await api.post(`/api/caregiverLogin`, body, {
                headers: {
                    "Authorization": '' // Override the default Authorization header
                }
            });
            setError('');
            const data = response.data;
            // sessionStorage.setItem('customers', JSON.stringify(customers));
            if (data.isFirstLogin) {
                navigate('/createAccount');
                return;
            }
            if (data.token && data.units) {
                const { token, exp, units, isFirstLogin, signedEula } = data;
                saveToken(token, exp);
                // sessionStorage.setItem('signedEula', signedEula.toString());
                // sessionStorage.setItem('isFirstLogin', isFirstLogin.toString());
                // sessionStorage.setItem('units', JSON.stringify(units));
                dispatch(login({
                    token,
                    units,
                    signedEula,
                    isFirstLogin,
                    user: data.user,
                }));
                if (!signedEula) {
                    navigate('/eula');
                    return;
                } else {
                    navigate('/dashboard'); // Redirect to dashboard if not first login
                }
                setTimeout(() => { // auto logout after 24 hours
                    dispatch(logout());
                    clearSession();
                    navigate('/login');
                }, 24 * 60 * 60 * 1000); // 24 hours in milliseconds
            } else {
                setError('Invalid login response. Please try again.');
            }


        } catch (error) {
            if (error.response && error.response.status === 401) {
                setError('Incorrect username or password.');
            } else if (error.response && error.response.status === 500) {
                setError('Server error. Please try again later.');
            } else {
                setError('An unexpected error occurred. Please try again.');
            }
        }
    };

    return (
        <Container maxWidth="xs">
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                minHeight="90vh"
            >
                <Typography variant="h4" component="h1" gutterBottom>
                    Login
                </Typography>
                {error && <Alert severity="error" sx={{ width: '100%', mb: 2 }}>{error}</Alert>} {/* Display error message */}
                <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="username"
                        label="Username"
                        name="username"
                        autoComplete="username"
                        autoFocus
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        sx={{ mt: 3, mb: 2 }}
                    >
                        Login
                    </Button>

                </Box>
                <Box
                    display="flex"
                    flexDirection="row"
                    alignItems="center"
                    justifyContent="space-between"
                    sx={{ width: '100%', mt: 1 }}
                >
                    <Typography
                        variant="body2"
                        align="center"
                        sx={{ mt: 1, color: 'text.primary', cursor: 'pointer' }}
                        onClick={() => navigate('/forgotPassword')}
                    >
                        Forgot Password
                    </Typography>
                    <Typography
                        variant="body2"
                        align="center"
                        sx={{ mt: 1, color: 'text.primary', cursor: 'pointer' }}
                        onClick={() => navigate('/createAccount')}
                    >
                        Create Account
                    </Typography>
                </Box>
            </Box>
        </Container>
    );
};

export default Login;